export default "__VITE_ASSET__BJFt6INF__"